const LOGIN_PENDING_KEY = "orsee.loginPending";

/**
 * Marks that *this* tab started a login, immediately before handing off to the
 * identity provider.
 *
 * The identity provider sends the browser back with the session token in the
 * query string. Without this marker the app would adopt a token from any URL it
 * is ever pointed at, so a crafted link could silently sign a visitor into an
 * attacker's account. sessionStorage survives the redirect round-trip in the
 * same tab, but an attacker's link cannot set it.
 */
const markLoginPending = () => {
  try {
    sessionStorage.setItem(LOGIN_PENDING_KEY, "1");
  } catch (err) {
    // Private-mode or storage-disabled browsers: the handoff below will simply
    // reject the token and the user is sent back to the landing page.
    console.warn("Could not record the pending login:", err);
  }
};

/**
 * Returns true at most once per login handoff, and clears the marker.
 */
const consumeLoginPending = () => {
  try {
    const pending = sessionStorage.getItem(LOGIN_PENDING_KEY) === "1";
    sessionStorage.removeItem(LOGIN_PENDING_KEY);
    return pending;
  } catch (err) {
    return false;
  }
};

export { markLoginPending, consumeLoginPending };
